import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo, useRef } from "react";
import { formatIntlUSD } from "../../chunks/utils.js";
import { CountUp } from "../../chunks/index.js";
import TimeAgo from "javascript-time-ago";
import ReactTimeAgo from "react-time-ago";
import { AnimatePresence } from "motion/react";
import { CCAMFlag } from "../../chunks/ccam-flag.js";
import './list.dashboard.css';function getListDashboardConfigFromURL(url) {
  const config = new URLSearchParams(url.search);
  const minimumDonationAmount = Number.parseInt(
    config.get("minDonation") ?? "5",
    10
  );
  const minimumHighlightAmount = Number.parseInt(
    config.get("highlight") ?? "5",
    10
  );
  const showMaxDonations = Number.parseInt(
    config.get("donorMin") ?? config.get("showMaxDonations") ?? "100",
    10
  );
  const streamerName = config.get("streamerName") ?? void 0;
  const ccamMode = config.get("ccam") !== null;
  const showAllDonations = (config.get("showAllDonations") ?? "yes") === "yes";
  const sortDonations = (config.get("disableDonationSorting") ?? "yes") === "yes";
  const showUserAmountRaised = (config.get("showUserAmountRaised") ?? "no") === "yes";
  const useSupportingAmountRaised = (config.get("useSupportingAmountRaised") ?? "no") === "yes";
  return {
    ccamMode,
    minimumDonationAmount,
    minimumHighlightAmount,
    streamerName,
    showAllDonations,
    showUserAmountRaised,
    showMaxDonations,
    sortDonations,
    useSupportingAmountRaised
  };
}
function StreamerInfo({
  userAmountRaised,
  streamerName,
  show = true
}) {
  if (!show) return null;
  return /* @__PURE__ */ jsxs("div", { className: "min-w-[400px] p-2 flex flex-col", children: [
    /* @__PURE__ */ jsx("span", { className: "streamer text-white font-bold text-lg", children: streamerName }),
    /* @__PURE__ */ jsxs("span", { className: "streamer_raised text-white font-bold text-2xl", children: [
      "$",
      /* @__PURE__ */ jsx(
        CountUp,
        {
          end: userAmountRaised,
          duration: 1,
          separator: ",",
          decimals: userAmountRaised - Math.floor(userAmountRaised) !== 0 ? 2 : 0,
          preserveValue: true,
          useEasing: false
        }
      )
    ] })
  ] });
}
const en = {
  "locale": "en",
  "long": {
    "year": {
      "previous": "last year",
      "current": "this year",
      "next": "next year",
      "past": {
        "one": "{0} year ago",
        "other": "{0} years ago"
      },
      "future": {
        "one": "in {0} year",
        "other": "in {0} years"
      }
    },
    "quarter": {
      "previous": "last quarter",
      "current": "this quarter",
      "next": "next quarter",
      "past": {
        "one": "{0} quarter ago",
        "other": "{0} quarters ago"
      },
      "future": {
        "one": "in {0} quarter",
        "other": "in {0} quarters"
      }
    },
    "month": {
      "previous": "last month",
      "current": "this month",
      "next": "next month",
      "past": {
        "one": "{0} month ago",
        "other": "{0} months ago"
      },
      "future": {
        "one": "in {0} month",
        "other": "in {0} months"
      }
    },
    "week": {
      "previous": "last week",
      "current": "this week",
      "next": "next week",
      "past": {
        "one": "{0} week ago",
        "other": "{0} weeks ago"
      },
      "future": {
        "one": "in {0} week",
        "other": "in {0} weeks"
      }
    },
    "day": {
      "previous": "yesterday",
      "current": "today",
      "next": "tomorrow",
      "past": {
        "one": "{0} day ago",
        "other": "{0} days ago"
      },
      "future": {
        "one": "in {0} day",
        "other": "in {0} days"
      }
    },
    "hour": {
      "current": "this hour",
      "past": {
        "one": "{0} hour ago",
        "other": "{0} hours ago"
      },
      "future": {
        "one": "in {0} hour",
        "other": "in {0} hours"
      }
    },
    "minute": {
      "current": "this minute",
      "past": {
        "one": "{0} minute ago",
        "other": "{0} minutes ago"
      },
      "future": {
        "one": "in {0} minute",
        "other": "in {0} minutes"
      }
    },
    "second": {
      "current": "now",
      "past": {
        "one": "{0} second ago",
        "other": "{0} seconds ago"
      },
      "future": {
        "one": "in {0} second",
        "other": "in {0} seconds"
      }
    }
  },
  "short": {
    "year": {
      "previous": "last yr.",
      "current": "this yr.",
      "next": "next yr.",
      "past": "{0} yr. ago",
      "future": "in {0} yr."
    },
    "quarter": {
      "previous": "last qtr.",
      "current": "this qtr.",
      "next": "next qtr.",
      "past": {
        "one": "{0} qtr. ago",
        "other": "{0} qtrs. ago"
      },
      "future": {
        "one": "in {0} qtr.",
        "other": "in {0} qtrs."
      }
    },
    "month": {
      "previous": "last mo.",
      "current": "this mo.",
      "next": "next mo.",
      "past": "{0} mo. ago",
      "future": "in {0} mo."
    },
    "week": {
      "previous": "last wk.",
      "current": "this wk.",
      "next": "next wk.",
      "past": "{0} wk. ago",
      "future": "in {0} wk."
    },
    "day": {
      "previous": "yesterday",
      "current": "today",
      "next": "tomorrow",
      "past": {
        "one": "{0} day ago",
        "other": "{0} days ago"
      },
      "future": {
        "one": "in {0} day",
        "other": "in {0} days"
      }
    },
    "hour": {
      "current": "this hour",
      "past": "{0} hr. ago",
      "future": "in {0} hr."
    },
    "minute": {
      "current": "this minute",
      "past": "{0} min. ago",
      "future": "in {0} min."
    },
    "second": {
      "current": "now",
      "past": "{0} sec. ago",
      "future": "in {0} sec."
    }
  },
  "narrow": {
    "year": {
      "previous": "last yr.",
      "current": "this yr.",
      "next": "next yr.",
      "past": "{0}y ago",
      "future": "in {0}y"
    },
    "quarter": {
      "previous": "last qtr.",
      "current": "this qtr.",
      "next": "next qtr.",
      "past": "{0}q ago",
      "future": "in {0}q"
    },
    "month": {
      "previous": "last mo.",
      "current": "this mo.",
      "next": "next mo.",
      "past": "{0}mo ago",
      "future": "in {0}mo"
    },
    "week": {
      "previous": "last wk.",
      "current": "this wk.",
      "next": "next wk.",
      "past": "{0}w ago",
      "future": "in {0}w"
    },
    "day": {
      "previous": "yesterday",
      "current": "today",
      "next": "tomorrow",
      "past": "{0}d ago",
      "future": "in {0}d"
    },
    "hour": {
      "current": "this hour",
      "past": "{0}h ago",
      "future": "in {0}h"
    },
    "minute": {
      "current": "this minute",
      "past": "{0}m ago",
      "future": "in {0}m"
    },
    "second": {
      "current": "now",
      "past": "{0}s ago",
      "future": "in {0}s"
    }
  },
  "now": {
    "now": {
      "current": "now",
      "future": "in a moment",
      "past": "just now"
    }
  },
  "mini": {
    "year": "{0}yr",
    "month": "{0}mo",
    "week": "{0}wk",
    "day": "{0}d",
    "hour": "{0}h",
    "minute": "{0}m",
    "second": "{0}s",
    "now": "now"
  },
  "short-time": {
    "year": "{0} yr.",
    "month": "{0} mo.",
    "week": "{0} wk.",
    "day": {
      "one": "{0} day",
      "other": "{0} days"
    },
    "hour": "{0} hr.",
    "minute": "{0} min.",
    "second": "{0} sec."
  },
  "long-time": {
    "year": {
      "one": "{0} year",
      "other": "{0} years"
    },
    "month": {
      "one": "{0} month",
      "other": "{0} months"
    },
    "week": {
      "one": "{0} week",
      "other": "{0} weeks"
    },
    "day": {
      "one": "{0} day",
      "other": "{0} days"
    },
    "hour": {
      "one": "{0} hour",
      "other": "{0} hours"
    },
    "minute": {
      "one": "{0} minute",
      "other": "{0} minutes"
    },
    "second": {
      "one": "{0} second",
      "other": "{0} seconds"
    }
  }
};
const LIST_DASHBOARD_DATA = {
  causes: [
    {
      id: "75263",
      name: "Red Wagon for St. Jude"
    },
    {
      id: "75264",
      name: "Art Supplies for St. Jude"
    },
    { id: "75269", name: "Family Meal Card for St. Jude" },
    { id: "75273", name: "No More Chemo Party" },
    { id: "75279", name: "2/3 Share of Chemotherapy Treatment" },
    { id: "77777", name: "New Toy for Hospital Play Areas" },
    { id: "77778", name: "Share of Bone Marrow Treatment" }
  ]
};
TimeAgo.addDefaultLocale(en);
function DonationList({
  donations,
  minimumDonationAmount,
  minimumHighlightAmount,
  campaignID,
  supportingCampaigns = []
}) {
  const excludedIDs = LIST_DASHBOARD_DATA.causes.map((cause) => cause.id);
  const campaignForDonation = (donation) => {
    if (donation.campaign_id) {
      const campaign = supportingCampaigns.find(
        (c) => c.id === donation.campaign_id
      );
      if (campaign) {
        return /* @__PURE__ */ jsx("p", { className: "donation-campaign", children: /* @__PURE__ */ jsxs("em", { children: [
          /* @__PURE__ */ jsx("strong", { children: "Donated to: " }),
          campaign.name
        ] }) });
      }
    }
    return null;
  };
  const donationsWithDate = useMemo(() => {
    return donations.map((donation) => {
      return {
        ...donation,
        completedAt: /* @__PURE__ */ new Date(`${donation.completed_at}`)
      };
    });
  }, [donations]);
  return /* @__PURE__ */ jsxs("div", { className: campaignID === "166464" ? "donors event" : "donors", children: [
    /* @__PURE__ */ jsx("p", { className: "header text-white", children: minimumDonationAmount > 0 ? `Recent Donations over $${minimumDonationAmount}` : "Recent Donations" }),
    /* @__PURE__ */ jsx(AnimatePresence, { children: /* @__PURE__ */ jsx("ul", { children: donationsWithDate.map((donor) => /* @__PURE__ */ jsxs(
      "li",
      {
        className: donor.numberAmount >= minimumHighlightAmount ? "tier5" : "normal",
        children: [
          /* @__PURE__ */ jsx("div", { className: "relative-time", children: /* @__PURE__ */ jsx(
            ReactTimeAgo,
            {
              timeStyle: "round",
              date: donor.completedAt,
              locale: "en-US"
            }
          ) }),
          /* @__PURE__ */ jsxs("strong", { children: [
            donor.donor_name,
            " "
          ] }),
          /* @__PURE__ */ jsxs("span", { className: "donation-amount", children: [
            "$",
            donor.numberAmount
          ] }),
          donor.donor_comment && /* @__PURE__ */ jsxs("p", { className: "donors_comment", children: [
            /* @__PURE__ */ jsx("strong", { children: "Comment: " }),
            donor.donor_comment
          ] }),
          donor.rewardName && !excludedIDs.includes(donor.rewardID) && /* @__PURE__ */ jsx("p", { className: "donors_reward", children: /* @__PURE__ */ jsxs("em", { children: [
            /* @__PURE__ */ jsx("strong", { children: "Reward: " }),
            donor.rewardName
          ] }) }),
          donor.causeName && /* @__PURE__ */ jsx("p", { className: "donors_reward", children: /* @__PURE__ */ jsxs("em", { children: [
            /* @__PURE__ */ jsx("strong", { children: "Reward: " }),
            donor.causeName
          ] }) }),
          donor.optionName && /* @__PURE__ */ jsx("p", { className: "donors_poll", children: /* @__PURE__ */ jsxs("em", { children: [
            /* @__PURE__ */ jsx("strong", { children: "Poll: " }),
            donor.optionName
          ] }) }),
          campaignForDonation(donor)
        ]
      },
      donor.id
    )) }) })
  ] });
}
function Thermometer({
  progress,
  currentAmount,
  goalAmount
}) {
  return /* @__PURE__ */ jsxs("div", { className: "content therm", children: [
    /* @__PURE__ */ jsx("div", { className: "therm_raised", children: formatIntlUSD(currentAmount) }),
    /* @__PURE__ */ jsx("div", { className: "therm_therm", children: /* @__PURE__ */ jsx("div", { className: "therm_therm__wrapper", children: /* @__PURE__ */ jsx(
      "div",
      {
        className: "therm_therm__inner",
        style: { width: `${progress}%` }
      }
    ) }) }),
    /* @__PURE__ */ jsx("div", { className: "therm_goal", children: formatIntlUSD(goalAmount) })
  ] });
}
function calculateProgress(currentAmount, goalAmount) {
  return currentAmount > goalAmount ? 100 : Math.round(100 * (currentAmount / goalAmount));
}
function sortListDashboardDonations(donations) {
  return donations.sort((a, b) => {
    return Number.parseFloat(a.amount.value) - Number.parseFloat(b.amount.value) || (/* @__PURE__ */ new Date(`${a.completed_at}`)).getTime() - (/* @__PURE__ */ new Date(`${b.completed_at}`)).getTime();
  });
}
function filterListDashboardDonations(donations, rewards, optionsList, minimumDonationAmount) {
  return donations.map((donation) => {
    const rewardItem = rewards.find((reward) => reward.id === donation.reward_id) || null;
    const causeItem = LIST_DASHBOARD_DATA.causes.find(
      (cause) => cause.id === donation.reward_id
    ) || null;
    const optionItem = optionsList.find((option) => option.id === donation.poll_option_id) || null;
    return {
      ...donation,
      rewardName: rewardItem ? rewardItem.name : null,
      causeName: causeItem ? causeItem.name : null,
      optionName: optionItem ? optionItem.name : null,
      rewardID: rewardItem ? rewardItem.id : null,
      numberAmount: Number.parseFloat(donation.amount.value)
    };
  }).filter((donation) => donation.numberAmount >= minimumDonationAmount);
}
function ListDashboard({
  campaignID,
  streamerName,
  goalAmount,
  currentAmount,
  minimumDonationAmount = 0,
  minimumHighlightAmount = 0,
  donations = [],
  polls = [],
  rewards = [],
  overallGoalAmount = goalAmount,
  overallCurrentAmount = currentAmount,
  ccamMode = false,
  showUserAmountRaised = false,
  showMaxDonations = 100,
  sortDonations = true,
  supportingCampaigns = [],
  full = true
}) {
  const startAmount = useRef(currentAmount);
  const userAmountRaised = useMemo(
    () => currentAmount - startAmount.current < 0 ? 0 : currentAmount - startAmount.current,
    [currentAmount]
  );
  const progress = calculateProgress(currentAmount, goalAmount);
  const overallProgress = calculateProgress(
    overallCurrentAmount,
    overallGoalAmount
  );
  const pollOptionsList = polls.flatMap((poll) => poll.options);
  let finalDonations = filterListDashboardDonations(
    donations,
    rewards,
    pollOptionsList,
    minimumDonationAmount
  ).slice(0, showMaxDonations);
  if (sortDonations)
    finalDonations = sortListDashboardDonations(finalDonations);
  const innerThermBlock = /* @__PURE__ */ jsxs("div", { className: "flex w-full items-center", children: [
    /* @__PURE__ */ jsx("div", { className: "therm_raised mr-4", children: formatIntlUSD(currentAmount) }),
    /* @__PURE__ */ jsx("div", { className: "therm_therm flex-1 mb-2", children: /* @__PURE__ */ jsx("div", { className: "therm_therm__wrapper", children: /* @__PURE__ */ jsx(
      "div",
      {
        className: "therm_therm__inner",
        style: { width: `${progress}%` }
      }
    ) }) }),
    /* @__PURE__ */ jsx("div", { className: "therm_goal ml-4", children: formatIntlUSD(goalAmount) })
  ] });
  const thermBlock = showUserAmountRaised ? /* @__PURE__ */ jsx("div", { className: "content therm w-full flex", children: innerThermBlock }) : innerThermBlock;
  return /* @__PURE__ */ jsxs("div", { className: `dashboard-list-overlay ${full && "full"}`, children: [
    /* @__PURE__ */ jsx("div", { className: "dashboard-list", children: /* @__PURE__ */ jsxs("section", { className: "flex flex-col h-full overflow-hidden", children: [
      /* @__PURE__ */ jsx("div", { className: "progress-wrapper mb-0 mt-2 mx-2", children: campaignID === "166464" ? /* @__PURE__ */ jsx(
        Thermometer,
        {
          progress: overallProgress,
          currentAmount: overallCurrentAmount,
          goalAmount: overallGoalAmount
        }
      ) : /* @__PURE__ */ jsxs("div", { className: "flex gutters constrain content therm", children: [
        /* @__PURE__ */ jsx(
          StreamerInfo,
          {
            userAmountRaised,
            streamerName,
            show: showUserAmountRaised
          }
        ),
        thermBlock
      ] }) }),
      /* @__PURE__ */ jsx("div", { className: "mx-2 mt-2 -mb-5 flex-1 overflow-hidden", children: /* @__PURE__ */ jsx(
        DonationList,
        {
          supportingCampaigns,
          donations: finalDonations,
          minimumDonationAmount,
          minimumHighlightAmount,
          campaignID
        }
      ) })
    ] }) }),
    /* @__PURE__ */ jsx(CCAMFlag, { show: ccamMode })
  ] });
}
export {
  ListDashboard,
  getListDashboardConfigFromURL
};
//# sourceMappingURL=list.dashboard.js.map
